<template><div><h1 id="umlagern-von-stucklisten" tabindex="-1"><a class="header-anchor" href="#umlagern-von-stucklisten"><span>Umlagern von Stücklisten</span></a></h1>
<p>Umlagern von Stücklisten — Stücklisten mit assemblierten Artikeln umlagern</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Das System benötigt die Angabe der gewünschten, über eine Stückliste zu assemblierenden Artikels. Es führt dann automatisch die notwendige Verfügbarkeitsprüfung aufgrund der Stückliste durch und erstellt alle notwendigen Buchungen. Der Buchungstyp &quot;S&quot; wird sowohl beim zu assemblierenden Normalartikel als auch bei den einzelnen Bestandteilen verwendet. Diese Umlagerungsart ist nur innerhalb eines Lagers möglich. Die umzulagernden Artikel sind in den <RouteLink to="/referenz/refs/ft.refadata.umlagerpos.html" title="Umlagern Positionen">Umlagerungspositionen</RouteLink> definiert.</p>
<p>Pfad: <code v-pre>Logistik → Verarbeitungsläufe → Umlagerungen → Stücklisten (Normal-Artikel)</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobdatum/Laufnr</dt>
<dd>
<p>Job-Identifikation, bestehend aus Jobdatum, Laufnummer</p>
</dd>
<dt>Status</dt>
<dd>
<p>Anzeige des Auftragsstatus:<br>1 = erfasst, nicht verarbeitet<br>2 = in Verarbeitung nach Status 1 (nur technischer Status, für den Benutzer nicht sichtbar)<br>3 = Lieferschein gedruckt<br>4 = in Verarbeitung nach Status 3 (nur technischer Status, für den Benutzer nicht sichtbar)<br>5 = abgeschlossen</p>
</dd>
<dt>von Lager</dt>
<dd>
<p>Auslieferlager, aus dem die Artikel geliefert werden</p>
</dd>
<dt>an Lager</dt>
<dd>
<p>Ziellager, in das die Artikel geliefert werden</p>
</dd>
<dt>Auslieferdatum</dt>
<dd>
<p>Datum, an dem die Auslieferung erfolgen soll. Damit können Umlagerungsaufträge analog normalen Aufträgen in die Zukunft terminiert werden.</p>
</dd>
<dd>
<p>Validierung: Das Auslieferungsdatum kann (ab dem Zeitpunkt, an dem der Lieferschein gedruckt werden soll) nur noch in einem Intervall zwischen [Heute -60 Tage] bis [Heute +7 Tage] angegeben werden. Umlagerungsaufträge können also bis 2 Monate rückwirkend und 1 Woche im voraus verarbeitet werden. Die Erfassung (ohne Verarbeitung) ist auch ausserhalb dieses Zeitraums möglich.</p>
</dd>
<dt>Empfangsdatum</dt>
<dd>
<p>Empfangsdatum: Datum, zu dem die Umlagerung im System vermerkt wird. Beim Verbuchen der bestätigten Mengen zeigt das System den Standardvorschlag = Tagesdatum. Dieses Datum kann geändert werden, womit auch rückwirkend Bewegungen ins System eingebucht werden können, was v.a. für die Inventur gebraucht wird</p>
</dd>
<dt>Partientyp</dt>
<dd>
<p>R = Retourenumlagerung (wird im Umlagerungskopf definiert), der Bewegungstyp ist &quot;U&quot;</p>
</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refadata.umlagerpos.html" title="Umlagern Positionen">Umlagerungspositionen</RouteLink></p>
</div></template>


